import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {authSelector} from "../redux/selectors";
import RequestResetForm from "./RequestResetForm";
import {getReset} from "../redux/actions";

class RequestReset extends Component {
    componentDidMount() {
        if (this.props.match.params.key) {
            this.props.verify(this.props.match.params.key)
        }
        document.title = "Addiction | Request Password Reset"
    }
    render() {
        if (!this.props.isAuthenticated) {
            if (!this.props.auth.passwordReset) {
                return (
                    <div>
                        <h1>Request Password Reset</h1>
                        <div className="panel">
                            <div className="panel-adt">
                                Enter your email address and we will send you instructions on how to reset your
                                password.
                                <RequestResetForm
                                    onSubmit={this.props.onSubmit}
                                    pending={this.props.pending}
                                    errors={this.props.auth.registerError}
                                />
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <h1>Reset Password</h1>
                        <div className="panel">
                            <div className="panel-adt">
                                <h4 className="text-primary">Success!</h4>
                                <p>Check your email for instructions.</p>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return <Redirect to="/" />

        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    isAuthenticated: state.auth.loggedIn,
    pending: state.auth.pending
});

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (values) => dispatch(getReset(values.email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestReset);


// WEBPACK FOOTER //
// ./src/Auth/RequestReset.js